import React from 'react';

const AchillesBadge = ({ type = 'guide', compact = false }) => {
  const isGuide = type === 'guide';

  const label = isGuide ? 'Achilles Guide' : 'Achilles Athlete';
  const icon = isGuide ? '\u{1F9AE}' : '\u{267F}'; // guide dog / accessibility

  if (compact) {
    return (
      <span aria-label={label} style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.3rem',
        padding: '0.15rem 0.5rem',
        background: 'rgba(56, 189, 248, 0.12)',
        color: '#38bdf8',
        borderRadius: '8px',
        fontSize: '0.7rem',
        fontWeight: 600,
      }}>
        {icon} {label}
      </span>
    );
  }

  return (
    <div aria-label={label} style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.4rem',
      padding: '0.3rem 0.75rem',
      background: 'rgba(56, 189, 248, 0.12)',
      border: '1px solid rgba(56, 189, 248, 0.25)',
      borderRadius: '12px',
      fontSize: '0.8rem',
      fontWeight: 600,
      color: '#38bdf8',
    }}>
      <span aria-hidden="true" style={{ fontSize: '0.9rem' }}>{icon}</span>
      {label}
    </div>
  );
};

export default AchillesBadge;
